import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

export const applyType = (type: string, value: any) => {
  if (type === 'Date') {
    return value && moment(value).format('MMM D, YYYY');
  }
  if (type === 'Boolean') {
    if (value === true) {
      return 'Yes';
    }
    if (value === false) {
      return 'No';
    }
  }
  if (type === 'Address' && typeof value === 'object' && value) {
    return (
      <Box>
        <Typography fontSize={12} fontWeight={500}>
          {value.street} {value?.street?.trim()?.endsWith(',') === true ? '' : ','} {value.city}
        </Typography>
        <Typography fontSize={12} fontWeight={500}>
          {value.stateProvince}, {value.country} - {value.postalCode}
        </Typography>
      </Box>
    );
  }

  return value;
};

export default applyType;
